export class ListaPrecoBulkDeleteRequest {
    idsListaPreco: number[]
}